"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationAppClient = void 0;
const accessors_1 = require("./connections/accessors");
const accessors_2 = require("./flows/accessors");
const accessors_3 = require("./data-links/accessors");
const accessors_4 = require("./integrations/accessors");
const accessors_5 = require("./field-mappings/accessors");
const accessors_6 = require("./data-sources/accessors");
const accessors_7 = require("./app-events/accessors");
const accessors_8 = require("./app-data-schemas/accessors");
const accessors_9 = require("./auth/accessors");
const api_client_1 = require("./api-client");
const accessors_10 = require("./flow-runs/accessors");
const iframe_1 = require("./iframe");
class IntegrationAppClient extends api_client_1.IntegrationAppApiClient {
    constructor(options) {
        super(options);
    }
    get self() {
        return new accessors_9.SelfAccessor(this);
    }
    get flows() {
        return new accessors_2.FlowsAccessor(this);
    }
    async open({ showPoweredBy = true, onClose, } = {
        showPoweredBy: true,
    }) {
        const uri = this.getEmbedUri(`/main/`, {
            showPoweredBy: showPoweredBy !== null && showPoweredBy !== void 0 ? showPoweredBy : true,
        });
        return (0, iframe_1.openIframe)(uri, {
            onClose,
        });
    }
    flow(keyOrId) {
        return new accessors_2.FlowAccessor(this, keyOrId);
    }
    get flowInstances() {
        return new accessors_2.FlowInstancesAccessor(this);
    }
    flowInstance(selector) {
        return new accessors_2.FlowInstanceAccessor(this, selector);
    }
    get dataSourceInstances() {
        return new accessors_6.DataSourceInstancesAccessor(this);
    }
    get dataSources() {
        return new accessors_6.DataSourcesAccessor(this);
    }
    dataSource(keyOrId) {
        return new accessors_6.DataSourceAccessor(this, keyOrId);
    }
    dataSourceInstance(selector) {
        return new accessors_6.DataSourceInstanceAccessor(this, selector);
    }
    get dataSourceEvents() {
        return new accessors_6.DataSourceEventsAccessor(this);
    }
    get fieldMappings() {
        return new accessors_5.FieldMappingsAccessor(this);
    }
    fieldMapping(idOrKey) {
        return new accessors_5.FieldMappingAccessor(this, idOrKey);
    }
    get fieldMappingInstances() {
        return new accessors_5.FieldMappingInstancesAccessor(this);
    }
    fieldMappingInstance(selector) {
        return new accessors_5.FieldMappingInstanceAccessor(this, selector);
    }
    get dataLinkTables() {
        return new accessors_3.DataLinkTablesAccessor(this);
    }
    dataLinkTable(idOrKey) {
        return new accessors_3.DataLinkTableAccessor(this, idOrKey);
    }
    get dataLinkTableInstances() {
        return new accessors_3.DataLinkTableInstancesAccessor(this);
    }
    dataLinkTableInstance(selector) {
        return new accessors_3.DataLinkTableInstanceAccessor(this, selector);
    }
    get integrations() {
        return new accessors_4.IntegrationsAccessor(this);
    }
    integration(identifier) {
        return new accessors_4.IntegrationAccessor(this, identifier);
    }
    get connections() {
        return new accessors_1.ConnectionsAccessor(this);
    }
    connection(id) {
        return new accessors_1.ConnectionAccessor(this, id);
    }
    get appEventTypes() {
        return new accessors_7.AppEventTypesAccessor(this);
    }
    appEventType(idOrKey) {
        return new accessors_7.AppEventTypeAccessor(this, idOrKey);
    }
    get appEventSubscriptions() {
        return new accessors_7.AppEventSubscriptionsAccessor(this);
    }
    appEventSubscription(selector) {
        return new accessors_7.AppEventSubscriptionAccessor(this, selector);
    }
    get appEvents() {
        return new accessors_7.AppEventsAccessor(this);
    }
    get flowRuns() {
        return new accessors_10.FlowRunsAccessor(this);
    }
    flowRun(id) {
        return new accessors_10.FlowRunAccessor(this, id);
    }
    get appDataSchemas() {
        return new accessors_8.AppDataSchemasAccessor(this);
    }
    appDataSchema(idOrKey) {
        return new accessors_8.AppDataSchemaAccessor(this, idOrKey);
    }
    get appDataSchemaInstances() {
        return new accessors_8.AppDataSchemaInstancesAccessor(this);
    }
    appDataSchemaInstance(selector) {
        return new accessors_8.AppDataSchemaInstanceAccessor(this, selector);
    }
    async connectionRequest(connectionId, uri, data) {
        return this.post(`connections/${connectionId}/execute-request`, {
            key: uri,
            payload: data,
        });
    }
}
exports.IntegrationAppClient = IntegrationAppClient;
//# sourceMappingURL=client.js.map